import { route } from 'preact-router';
import { actionTypes } from './index';
import { resetPost, resetPut } from '../api/security';
// eslint-disable-next-line import/no-cycle
import { routes } from '../components/app';
import { selectForgotPasswordResettingParams } from '../reducers/forgotPassword';
import { TOKEN_TYPES } from '../utils/consts';

export function forgotPasswordPost(params) {
  return async (dispatch) => {
    try {
      dispatch({
        type: actionTypes.FORGOT_PASSWORD_POST_REQUEST,
        payload: { params },
      });

      const { message } = await resetPost(params);

      dispatch(forgotPasswordPostSuccess(message));
    } catch ({ message }) {
      dispatch(forgotPasswordPostFailure(message));
    }
  };
}

function forgotPasswordPostSuccess(successMessage) {
  return {
    type: actionTypes.FORGOT_PASSWORD_POST_SUCCESS,
    payload: { successMessage },
  };
}

function forgotPasswordPostFailure(error) {
  return {
    error,
    type: actionTypes.FORGOT_PASSWORD_POST_FAILURE,
  };
}

export function forgotPasswordSetResettingMode(resettingParams) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FORGOT_PASSWORD_SET_RESETTING_MODE,
      payload: { resettingParams },
    });

    route(routes.FORGOT_PASSWORD);
  };
}

export function forgotPasswordReset(params) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: actionTypes.FORGOT_PASSWORD_RESET_REQUEST,
        payload: { params },
      });

      const resettingParams = selectForgotPasswordResettingParams(getState());

      const { message } = await resetPut({
        ...resettingParams,
        ...params,
        tokenType: TOKEN_TYPES.RESET_PASSWORD,
      });

      dispatch(forgotPasswordResetSuccess(message));
    } catch ({ message }) {
      dispatch(forgotPasswordResetFailure(message));
    }
  };
}

function forgotPasswordResetSuccess(successMessage) {
  return {
    type: actionTypes.FORGOT_PASSWORD_RESET_SUCCESS,
    payload: { successMessage },
  };
}

function forgotPasswordResetFailure(error) {
  return {
    error,
    type: actionTypes.FORGOT_PASSWORD_RESET_FAILURE,
  };
}



// WEBPACK FOOTER //
// ./actions/forgotPassword.js